import { render, staticRenderFns } from "./BookWindow.vue?vue&type=template&id=08a87738&scoped=true&"
import script from "./BookWindow.vue?vue&type=script&lang=js&"
export * from "./BookWindow.vue?vue&type=script&lang=js&"
import style0 from "./BookWindow.vue?vue&type=style&index=0&id=08a87738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a87738",
  null
  
)

export default component.exports